module.exports = __webpack_public_path__ + "img/dog3.4e5631d8.svg";